/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

const pathname = '/standard-products';

export const StandardProductApi = {
  find: async (options: FindStandardProductOptions) => {
    let url = pathname;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findStandardDiaries: async (id: string, options: any) => {
    let url = `${pathname}/${id}/diaries`;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },
};

export interface FindStandardProductOptions {
  page: number;
  take: number;
  standardProcessID: string;
  name?: string;
  subCategoryID?: string;
}
